import * as React from 'react';

interface BtnActionOperateurCorrectionProps {
  needCorrectionsChange: any
  disabled: boolean
}

export const BtnActionOperateurCorrection = (props: BtnActionOperateurCorrectionProps) => {

  const strTitle = 'Correction gratuite';
  const strTitle2 = 'par un opérateur (+24h)';


  return (
    <div className=" col-lg-4 col-md-4 col-12 d-flex my-2 my-lg-0 align-items-center" >
      <button disabled={props.disabled} id={"correctionOperateur"} onClick={(e) => {props.needCorrectionsChange(true)}} className={`d-flex flex-column flex-lg-row  w-100  text-center d-flex  justify-content-center align-items-center btnBatAuto btnBatAutoPrimary  black text-center ${props.disabled ? 'grey cursor-notAllowed opacDisabled ' : '  cursor-pointer '} `}>
            <span className={'bold'}>
               {strTitle}
            </span>
        <span>&nbsp;{strTitle2}</span>
      </button>
    </div>
  );
}